import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';

// Custom hook that returns the about pages with translated headers
export const useAboutPages = () => {
    const { t } = useContext(LanguageContext);
    return [
        {
            header: t('about_page1_title') || 'About Us',
            textBase: 'about1',
        },
        {
            header: t('about_page2_title') || 'Our Mission',
            textBase: 'about2',
        },
        {
            header: t('about_page3_title') || 'Get Involved',
            textBase: 'about3',
        },
    ];
};

export default useAboutPages;
